import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  padding: {
    paddingTop: 16,
  }
}));

export default styles;